import RichContent from './RichContent'
// Uncomment the below to migrate to stateful component
// import RichContentContainer from './RichContentContainer'

export { RichContent }
export default RichContent
// Uncomment the below to migrate to stateful component
// export { RichContentContainer }
// export default { RichContentContainer }
